import { c as _c } from "react/compiler-runtime";
import { LUX_PAGE_LABELS, LUX_USER_DATA, sendLuxUserData, setLuxPageLabel } from 'commons/lux';
import { useEffect } from 'react';
const usePDPLuxAnalytics = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
};
export default usePDPLuxAnalytics;
function _temp() {
  return setLuxPageLabel(LUX_PAGE_LABELS.UNSET);
}
function _temp2() {
  setLuxPageLabel(LUX_PAGE_LABELS.PDPv2);
  sendLuxUserData(LUX_USER_DATA.PDP, "v2");
  return _temp;
}